export default "__VITE_ASSET__Dv$yGYtU__"